import { Box, styled } from "@mui/material";

export const WidgetsWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
`;

export const WidgetCol = styled(Box)`
  display: flex;
  width: calc(50% - 8px);

  @media (min-width: 992px) {
    width: calc(33.333% - 11px);
  }
`;
